import { getCurrentFocusKey } from '@noriginmedia/norigin-spatial-navigation'
import { ContentActionButtonLabel } from './types'

declare const COMCAST_IN_APP_DONATIONS_ENABLED: boolean
declare const COMPILING_FOR_COMCASTX1: boolean
export const donationFeatureEnabled =
  COMCAST_IN_APP_DONATIONS_ENABLED && COMPILING_FOR_COMCASTX1

export const NOT_YET_AVAILABLE = 'not-yet-available'
export const AVAILABILITY = 'availability'

export const getPlayButtonDetails = (videoDetails) => {
  const watchedPercent =
    (videoDetails.seconds_watched / videoDetails.duration) * 100
  const shouldPlayContent =
    videoDetails.seconds_watched < 30 || watchedPercent > 95

  const actionLabel = shouldPlayContent
    ? ContentActionButtonLabel.PLAY
    : ContentActionButtonLabel.RESUME

  return {
    label: actionLabel,
  }
}

export const getCurrentlyFocused = (
  ContentActionButtonFocusKeys: string
): boolean => {
  const currentFocusKey = getCurrentFocusKey()
  return currentFocusKey === ContentActionButtonFocusKeys
}
